export const loadData = async() => {
    let arrayCitys = [];
    let dataResponse = await fetch('https://raw.githubusercontent.com/marcovega/colombia-json/master/colombia.min.json');
    let dataJson = await dataResponse.json();
    let citys = dataJson.map((value) => {
        let element = Object.values(value.ciudades);
        return element
    })

    citys.forEach(e => {
        e.forEach(el => {
            arrayCitys.push(el);
        })
    });


    return {places:dataJson, citys:arrayCitys.sort()};
}

